<template>
  <div class="gfr-container">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.gfr-container {
  @apply mx-auto h-full w-full 2xl:max-w-8xl max-2xl:px-5 max-lg:w-full;
}
</style>
